import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';

import { itemListSchemaOrg } from '../../util/schemaOrg';

function serializeJsonForScriptTag(value) {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}

/**
 * SSR 최초 렌더링(첫 페이지)에서만 schema.org JSON-LD 스크립트를 생성하고
 * 이후에도 DOM에서 유지되는 컴포넌트
 */
function SchemaOrgItemList({ offset, items, schemaOrgPreview, keyword }) {
  const schemaRef = useRef(null);

  // 최초 조건을 만족하면 schemaRef에 저장 (한번만)
  if (
    !schemaRef.current &&
    offset === 0 &&
    schemaOrgPreview &&
    Array.isArray(items) &&
    items.length > 0
  ) {
    const itemListSchema = itemListSchemaOrg(items, keyword);
    schemaRef.current = {
      '@context': 'https://schema.org',
      '@graph': [schemaOrgPreview, itemListSchema],
    };
  }

  if (!schemaRef.current) return null;

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: serializeJsonForScriptTag(schemaRef.current),
      }}
    />
  );
}

SchemaOrgItemList.propTypes = {
  offset: PropTypes.number.isRequired,
  items: PropTypes.array,
  schemaOrgPreview: PropTypes.object,
  keyword: PropTypes.string,
};

export default memo(SchemaOrgItemList);
